"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "es": {
        "translation": {
            "left_navigation": {
                "loading": "Cargando",
                "hidden_target": "No se puede mostrar la selección debido a los filtros aplicados. Para mostrar el elemento, retire el o los filtros apropiados.",
                "sidenav_open": "Abrir la navegación",
                "sidenav_close": "Cerrar la navegación",
                "expand": "Expandir",
                "collapse": "Contraer",
                "small_search": "Por favor, escriba al menos 2 caracteres para realizar la búsqueda.",
                "no_search_results": "No se han encontrado resultados de búsqueda.",
                "filter_search": "Filtrar...",
                "collection_archive": "Archivo de colección",
                "activities": {
                    "title": "Actividad",
                    "details": "Detalles",
                    "reset": "Restaurar",
                    "load_more": "Cargar más",
                    "no_results": "No hay actividades para el filtro especificado.",
                    "no_more_results": "Ha llegado al final de las actividades del filtro especificado.",
                    "actions": {
                        "created": "Creado/a",
                        "deleted": "Eliminado/a",
                        "updated": "Actualizado/a"
                    }
                },
                "settings": {
                    "title": "Configuración"
                }
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=es.js.map